export const SET_PRODUCT_CATEGORY = 'SET_PRODUCT_CATEGORY'
export const RESET_PRODUCT_CATEGORY = 'RESET_PRODUCT_CATEGORY'
